import { Link, NavLink, Outlet } from 'react-router-dom';
import { Button, ThemeToggle } from '@usacow/ds';

/** Public marketing shell: nav + footer. Free-first, no pricing anywhere. */
export function MarketingLayout() {
  return (
    <div className="mkt">
      <header className="mkt-nav">
        <Link to="/" className="mkt-nav__brand">
          <img src="/logo-mark.svg" width={28} height={28} alt="" />
          <span>usaCow</span>
        </Link>
        <nav className="mkt-nav__links">
          <NavLink to="/how-it-works">How it works</NavLink>
          <NavLink to="/about">About</NavLink>
          <ThemeToggle />
          <Link to="/auth" className="mkt-nav__cta">
            <Button variant="primary" size="sm">
              Sign in
            </Button>
          </Link>
        </nav>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="mkt-foot">
        <div className="mkt-foot__brand">
          <img src="/logo-mark.svg" width={22} height={22} alt="" />
          <span>usaCow</span>
        </div>
        <nav className="mkt-foot__links">
          <Link to="/how-it-works">How it works</Link>
          <Link to="/about">About</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/auth">Sign in</Link>
        </nav>
        <p className="mkt-foot__fine">
          Free for the foreseeable future. No card, no ads, no data sold.
        </p>
      </footer>
    </div>
  );
}
